import { useContext } from "react";
import { GlobalContext } from "../util/globalContext";

export function useDashboardApi() {
  const { config, apiFetch } = useContext(GlobalContext);
  const BASE_URL = config?.REACT_APP_BASE_URL || "http://localhost:3000";

  // ✅ Utility to get headers with token
  function getAuthHeaders() {
    const token = localStorage.getItem("token");
    return {
      "Content-Type": "application/json",
      "X-token": token || "",
    };
  }

  // =========================
  // 🔥 MAINTENANCE OVERVIEW (NEW)
  // =========================

  async function getMaintenanceOverview() {
    debugger
    const response = await apiFetch(`${BASE_URL}/get_maintenance_overview`, {
      method: "POST",
      headers: getAuthHeaders(),
      body: JSON.stringify({}), // empty body
    });

    const data = await response.json();
    if (!response.ok || !data.success) {
      throw new Error(data.message || "Failed to fetch maintenance overview");
    }
    return data;
  }


  // =========================
  // 🔔 SEND MAINTENANCE REMINDER
  // =========================
  async function sendMaintenanceReminder({
    manufacturerId,
    totalBales,
    status, // ALERT | DUE
    alertBales
  }) {
    const response = await apiFetch(
      `${BASE_URL}/send_maintenance_reminder`,
      {
        method: "POST",
        headers: getAuthHeaders(),
        body: JSON.stringify({
          manufacturerId,
          totalBales,
          status,
          alertBales
        }),
      }
    );

    const data = await response.json();
    if (!response.ok || !data.success) {
      throw new Error(
        data.message || "Failed to send maintenance reminder"
      );
    }

    return data;
  }

    // =========================
  // ⚙️ GET MAINTENANCE CONFIG  ✅ NEW
  // =========================
  async function getMaintenanceConfig() {
    const response = await apiFetch(`${BASE_URL}/get_maintenance_config`, {
      method: "GET",
      headers: getAuthHeaders(),
    });

    const res = await response.json();

    if (!response.ok || !res.success) {
      throw new Error(res.message || "Failed to fetch maintenance config");
    }

    return res.data; // ✅ RETURN ONLY DATA
  }


  // =========================
  // 🛠 UPDATE MAINTENANCE CONFIG  ✅ NEW
  // =========================
async function updateMaintenanceConfig({
  firstServiceAlert,
  serviceInterval,
  warningWindow, // ✅ ADD THIS
}) {
  const response = await apiFetch(
    `${BASE_URL}/update_maintenance_config`,
    {
      method: "POST",
      headers: getAuthHeaders(),
      body: JSON.stringify({
        firstServiceAlert,
        serviceInterval,
        warningWindow, // ✅ SEND TO API
      }),
    }
  );

  const res = await response.json();

  if (!response.ok || !res.success) {
    throw new Error(res.message || "Failed to update maintenance config");
  }

  return res.data;
}

  // =========================
// ✅ RESOLVE MAINTENANCE (BY manufacturerId)
// =========================
async function resolveMaintenanceNotification({ manufacturerId }) {
  const response = await apiFetch(
    `${BASE_URL}/resolve_maintenance_notification`,
    {
      method: "POST",
      headers: getAuthHeaders(),
      body: JSON.stringify({ manufacturerId }),
    }
  );

  const data = await response.json();
  if (!response.ok || !data.success) {
    throw new Error(data.message || "Failed to resolve maintenance");
  }

  return data;
}


  // =========================
  // EXPORT
  // =========================

  return {
    getMaintenanceOverview,
    sendMaintenanceReminder,
    getMaintenanceConfig,
    updateMaintenanceConfig,
    resolveMaintenanceNotification
  };
}
